import React from "react";
import checkoutAccordianStyles from "repoV2/features/CheckoutPages/modules/CheckoutAccordion/CheckoutAccordion.module.scss";
import useGetFormData from "repoV2/features/Common/modules/FormData/utils/useGetFormData";
import { IUserDetails } from "repoV2/features/Common/modules/FormData/interfaces/UserDetailsFormGroup.interfaces";
import {
    FORM_KEYS,
    multiple_users_helpers_keys,
} from "repoV2/features/Common/modules/FormData/FormData.constants";
import { IMultipleUsersHelpers } from "repoV2/features/Common/modules/FormData/interfaces/MultipleUserHelpers.interfaces";
import CheckoutAccordion from "../../../../../CheckoutAccordion/CheckoutAccordion";
import UserDetailsFormGroupHeader from "./modules/UserDetailsFormGroupHeader/UserDetailsFormGroupHeader";
import UserDetailsForm from "./modules/UserDetailsForm/UserDetailsForm";
import SingleUserCard from "./modules/SingleUserCard/SingleUserCard";
import useMultipleUserDetails from "./utils/useMultipleUserDetails";
import UserDetailsModal from "./modules/UserDetailsModal/UserDetailsModal";
import styles from "./UserDetailsFormGroup.module.scss";
import AddNewUsers from "./modules/AddNewUsers/AddNewUsers";

const UserDetailsFormGroup = () => {
    const {
        hideAddNewUserButton = false,
        handleEditUser,
        handleRemoveUser,
        handleAddNewUser,
        singleUserId,
        enableMultipleUserCountFlow = false,
    } = useMultipleUserDetails();

    const userDetails = useGetFormData<{ [userId: string]: IUserDetails }>({
        key: `${FORM_KEYS.user_details}`,
    });
    const allUserIds = useGetFormData<IMultipleUsersHelpers["allUserIds"]>({
        key: `${FORM_KEYS.multiple_users_helpers}.${multiple_users_helpers_keys.all_user_ids}`,
    });

    return (
        <>
            <CheckoutAccordion
                defaultExpanded
                showExpandIcon={false}
                title={<UserDetailsFormGroupHeader />}
                className={checkoutAccordianStyles.Wrapper}
                disabled
                classes={{
                    root: checkoutAccordianStyles.formGroupRoot,
                    disabled: checkoutAccordianStyles.formGroupDisabled,
                }}
                headerClasses={{
                    root: checkoutAccordianStyles.headerRoot,
                    content: checkoutAccordianStyles.headerContent,
                    disabled: checkoutAccordianStyles.formGroupDisabled,
                    expanded: checkoutAccordianStyles.formGroupExpanded,
                }}
            >
                {/* If there are more than one user, render them in indivudual cards,
                else render the form fields for the single user */}
                {allUserIds?.length > 1 ? (
                    <div className={styles.singleUsersContainer}>
                        {allUserIds.map(userIdData => {
                            const currentUserDetails =
                                userDetails?.[userIdData.userId] || {};
                            return (
                                <SingleUserCard
                                    key={userIdData.userId}
                                    singleUserDetails={currentUserDetails}
                                    currentUserId={userIdData.userId}
                                    onDelete={handleRemoveUser}
                                    onEdit={handleEditUser}
                                />
                            );
                        })}
                    </div>
                ) : (
                    <UserDetailsForm userId={singleUserId} />
                )}
                {/* Todo: Remove this for appointments and merchandise scenerio, also 
                backend gives a check to disable multiple users, handle that as well */}
                {!hideAddNewUserButton ? (
                    <AddNewUsers
                        enableMultipleUserCountFlow={
                            enableMultipleUserCountFlow
                        }
                        handleAddNewUser={handleAddNewUser}
                        allUserIds={allUserIds}
                    />
                ) : (
                    <></>
                )}
            </CheckoutAccordion>
            <UserDetailsModal />
        </>
    );
};

export default UserDetailsFormGroup;
